module.exports = __webpack_public_path__ + "img/logo-afx.023c1197.png";